import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { UserProvider } from "./UserContext";
import store from "./app/store";
import Dashboard2 from "./app/dashboard/Dashboard2";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/">
      {/* adapte le basename selon ton déploiement  <BrowserRouter basename="/Nadine_Braiding">*/}
      <UserProvider>
        <App />
      </UserProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);